import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { defaultResource, resourceFromAttributes } from '@opentelemetry/resources';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { context } from '@opentelemetry/api';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import packageJson from '../../../../../package.json';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';

@Injectable({
  providedIn: 'root'
})
export class TelemetryService {
  private tracerProvider: WebTracerProvider | null = null;

  constructor() {}

  initialize(): void {
    if (!environment.signozUrl || environment.signozUrl.trim() === '') {
      console.log('Signoz telemetry disabled - signozUrl not configured');
      return;
    }

    try {
      const customResource = resourceFromAttributes({
        [ATTR_SERVICE_NAME]: environment.signozServiceName,
        [ATTR_SERVICE_VERSION]: packageJson.version,
        'deployment.environment': environment.signozEnv || 'unknown',
      });
      const resource = defaultResource().merge(customResource);

      const traceExporter = new OTLPTraceExporter({
        url: `${environment.signozUrl}/v1/traces`,
      });

      context.setGlobalContextManager(new ZoneContextManager());

      this.tracerProvider = new WebTracerProvider({
        resource,
        spanProcessors: [
          new BatchSpanProcessor(traceExporter)
        ],
      });

      registerInstrumentations({
        instrumentations: [
          new DocumentLoadInstrumentation(),
          new FetchInstrumentation({
            propagateTraceHeaderCorsUrls: [
              new RegExp(environment.apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'),
            ],
          }),
          new XMLHttpRequestInstrumentation({
            propagateTraceHeaderCorsUrls: [
              new RegExp(environment.apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'),
            ],
          }),
        ],
        tracerProvider: this.tracerProvider,
      });

      this.tracerProvider.register();

      console.log(`Signoz telemetry initialized for env: ${environment.signozEnv}`);
    } catch (error) {
      console.error('Failed to initialize Signoz telemetry:', error);
    }
  }

  shutdown(): void {
    if (this.tracerProvider) {
      this.tracerProvider.shutdown();
      this.tracerProvider = null;
    }
  }
}

